<template>
    <div>
        <Hero />

        <div class="p-8 md:p-20">
            <div class="grid lg:grid-cols-2 gap-y-4">
                <div>
                    <div class="uppercase font-bold text-xl">why we give and what we give to</div>
                    <div class="text-lg mt-3">
                        <p>We have taken on that Global Mandate of Jesus Christ to preach the gospel, disciple men and demonstrate the power of God. We believe that God's greatest desire is to see all men saved and so we are focused on raising men to carry out God's vision.Come and join us in fulfilling this vision of taking the Gospel of Jesus to the uttermost ends of the earth. </p>
                    
                        <p class="mt-5">In our commitment to Christ's work on the earth, It is necessary to give in order to support the growth of his church, and to also be part of his plan on the earth.
                        We humbly request your financial support as we take God's will to the ends of the earth.
                        Thank you for your generous support.</p>
                    </div>
                </div>

                <div class="md:ps-10 pt-5 md:pt-0 text-lg flex flex-col gap-5">
                    <div>
                        <div class="uppercase font-bold hover:cursor-pointer">Bank Transfer <i class="fa-solid fa-chevron-down"></i></div>
                        <div class="grid grid-cols-2 md:ps-10 py-5">
                            <div class="font-bold">Account Name:</div>
                            <div>The Saints Gathering Church</div>
                            
                            <div class="font-bold">Bank Name:</div>
                            <div>United Bank of Africa (UBA)</div>

                            <div class="font-bold">Account Number:</div>
                            <div>2165136581</div>
                        </div>
                    </div>

                    <div>
                        <div class="uppercase font-bold hover:cursor-pointer">Bank Transfer (Dollar Account) <i class="fa-solid fa-chevron-down"></i></div>
                        <div class="grid grid-cols-2 md:ps-10 py-5">
                            <div class="font-bold">Account Name:</div>
                            <div>The Saints Gathering Church</div>
                            
                            <div class="font-bold">Bank Name:</div>
                            <div>Wema bank</div>

                            <div class="font-bold">Account Number:</div>
                            <div>0621568680</div>

                            <div class="font-bold">Sort Code:</div>
                            <div>035252166</div>

                            <div class="font-bold">Swift Code:</div>
                            <div>WEMANGLAXXX</div>
                            
                            <div class="font-bold">Swift Address:</div>
                            <div>Wema Towers 54, Marina, Lagos</div>
                            
                            <div class="font-bold">Correspondence Bank:</div>
                            <div>Standard Chartered</div>
                            
                            <div class="font-bold">Correspondence Address:</div>
                            <div>New York,NY US</div>
                        </div>
                    </div>
                    
                    <!-- <div>
                        <div class="uppercase font-bold hover:cursor-pointer" @click="showCreditCard = !showCreditCard">give now with credit/ debit card <i class="fa-solid fa-chevron-down"></i></div>
                        <div class="md:ps-10 py-5">
                            <form class="flex flex-wrap gap-3 w-full">
                                <label class="relative w-full flex flex-col">
                                    <span class="font-bold mb-3">Card number</span>
                                    <input class="rounded-md peer pl-12 pr-2 py-2 border-2 border-gray-200 placeholder-gray-300" type="number" name="card_number" placeholder="0000 0000 0000 0000" />
                                    <i class="fa-regular fa-credit-card absolute bottom-0 left-0 -mb-0.5 transform translate-x-1/2 -translate-y-1/2 text-black peer-placeholder-shown:text-gray-300 h-6 w-6"></i>
                                </label>

                                <label class="relative flex-1 flex flex-col">
                                    <span class="font-bold mb-3">Expire date</span>
                                    <input class="rounded-md peer pl-12 pr-2 py-2 border-2 border-gray-200 placeholder-gray-300" type="text" name="expire_date" placeholder="MM/YY" />
                                    <i class="fa-solid fa-calendar-days absolute bottom-0 left-0 -mb-0.5 transform translate-x-1/2 -translate-y-1/2 text-black peer-placeholder-shown:text-gray-300 h-6 w-6"></i>
                                </label>

                                <label class="relative flex-1 flex flex-col">
                                    <span class="font-bold flex items-center gap-3 mb-3">
                                    CVC/CVV
                                    <span class="relative group">
                                        <span class="hidden group-hover:flex justify-center items-center px-2 py-1 text-xs absolute -right-2 transform translate-x-full -translate-y-1/2 w-max top-1/2 bg-[#111315] text-white"> The CVV is a 3 or 4 digit code located at the back of your card.</span>
                                        <i class="fa-regular fa-circle-question"></i>
                                    </span>
                                    </span>
                                    <input class="rounded-md peer pl-12 pr-2 py-2 border-2 border-gray-200 placeholder-gray-300" type="number" name="card_cvc" placeholder="&bull;&bull;&bull;" />
                                    <i class="fa-solid fa-lock absolute bottom-0 left-0 -mb-0.5 transform translate-x-1/2 -translate-y-1/2 text-black peer-placeholder-shown:text-gray-300 h-6 w-6"></i>
                                </label>
                            </form>

                            <div class="p-3 rounded text-white text-center mt-4 bg-[#111315] hover:cursor-pointer">
                                    Give
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import Hero from '../components/Give/Hero.vue';

</script>

<style scoped>
</style>